import React from 'react';
import {useSelector} from "react-redux";
import {getRowNumber} from "mindsets-js-sdk";

import Row from './Row';

export default function () {
    const items = useSelector(state => state.questions);
    const current = useSelector(state => state.questions_current);
    const limit = useSelector(state => state.questions_limit);

    return (
        <div className="table-responsive announcements-table">
            <table className="table table-bordered table-hover">
                <thead>
                <tr className="text-center">
                    <th scope="col">#</th>
                    <th scope="col">ID</th>
                    <th scope="col">Details</th>
                    <th scope="col">Title</th>
                    <th scope="col">Practices</th>
                </tr>
                </thead>
                <tbody>
                {items.map((item, index) => {
                    return <Row
                        key={item.id}
                        item={item}
                        row_number={getRowNumber(index, current, limit)}
                    />;
                })}
                </tbody>
            </table>
        </div>
    );
}
